import { Logger } from '@core/types';

export class ConsoleLogger implements Logger {
  private debugEnabled: boolean;
  private prefix: string;

  constructor(debug: boolean = false, prefix: string = '[Campaign]') {
    this.debugEnabled = debug;
    this.prefix = prefix;
  }

  debug(...args: any[]): void {
    if (this.debugEnabled) {
      console.debug(this.prefix, ...args);
    }
  }

  info(...args: any[]): void {
    if (this.debugEnabled) {
      console.info(this.prefix, ...args);
    }
  }

  warn(...args: any[]): void {
    console.warn(this.prefix, ...args);
  }

  error(...args: any[]): void {
    console.error(this.prefix, ...args);
  }

  setDebug(debug: boolean): void {
    this.debugEnabled = debug;
  }

  setPrefix(prefix: string): void {
    this.prefix = prefix;
  }
}

export class NoopLogger implements Logger {
  debug(): void {}
  info(): void {}
  warn(): void {}
  error(): void {}
}

export function createLogger(debug: boolean = false): Logger {
  return new ConsoleLogger(debug);
}
